import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aab41222: FaireBrandEntity = {
  token: "b_aab41222",
  type: "brand",
  name: "Artifact",
  avatarUrl:
    "https://cdn.faire.com/fastly/c8c69e8fc1ac4760f625bbdab3610c38d44a2fafbe832dc88d38b6919623ed3c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4a2f7ed7c8beed6e6d737bef312d09247003ecc200f5d06c486f8bbdd4e2162.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c8c69e8fc1ac4760f625bbdab3610c38d44a2fafbe832dc88d38b6919623ed3c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4a2f7ed7c8beed6e6d737bef312d09247003ecc200f5d06c486f8bbdd4e2162.jpeg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 19,
  isInsider: false,
  description:
    "A Skincare Voyage ~ Discover your everyday self-care with Artifact. We formulate thoughtful, attention to detail, everyday skincare products: Face, Lips, Hair & Body Care.\n\nWe design products that complement and enhance the daily self-care ritual, using only the highest quality active ingredients and botanicals that are effective, high-performance and always non-toxic. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:30:37.107Z",
    importedBy: "entity-db-cli",
  },
};
